import React from "react";

function LoadingIndicator() {
    return (
        <div className='loading-overlay'>
            <span className='pulsing-text'>
                Loading...
            </span>
        </div>
    )
} 

export default LoadingIndicator;